<ng-container *ngIf="!settings.openOnClick">
    <div
        (mouseover)="isOpen = true"
        (mouseout)="isOpen = false"
        type="button"
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
        class="datiq-tooltip__trigger"
        [ngClass]="triggerClass"
    >
        <ng-container *ngIf="!settings?.hideIcon">
            <mat-icon
                [style.--datiq-tooltip-icon-size]="triggerIconSize + 'px'"
                [svgIcon]="settings?.icon"
            ></mat-icon>
        </ng-container>
        <ng-content select="[datiq-tooltip-label]"></ng-content>
    </div>

    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="isOpen"
        (backdropClick)="isOpen = false"
    >
        <div
            class="datiq-tooltip"
            [ngClass]="{ 'datiq-tooltip--info': isInfo }"
        >
            <header class="datiq-tooltip__header">
                <span
                    class="datiq-tooltip__header__label"
                    [datiqTemplateMd]="settings?.title"
                ></span>
            </header>
            <ng-container *ngIf="settings?.description?.length">
                <section class="datiq-tooltip__description">
                    <span class="datiq-tooltip__description__icon"
                        ><mat-icon svgIcon="app:info"></mat-icon
                    ></span>
                    <span
                        class="datiq-tooltip__description__label"
                        [datiqTemplateMd]="settings?.description"
                    ></span>
                </section>
            </ng-container>
        </div>
    </ng-template>
</ng-container>
<ng-container *ngIf="settings.openOnClick">
    <div
        (click)="isOpen = !isOpen"
        type="button"
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
        class="datiq-tooltip__trigger cursor-pointer"
        [ngClass]="triggerClass"
    >
        <ng-container *ngIf="!settings?.hideIcon">
            <mat-icon
                [style.--datiq-tooltip-icon-size]="triggerIconSize + 'px'"
                [svgIcon]="settings?.icon"
            ></mat-icon>
        </ng-container>
        <ng-content select="[datiq-tooltip-label]"></ng-content>
    </div>

    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="isOpen"
        (backdropClick)="isOpen = false"
    >
        <div
            class="datiq-tooltip"
            [ngClass]="{ 'datiq-tooltip--info': isInfo }"
        >
            <header class="datiq-tooltip__header">
                <span
                    class="datiq-tooltip__header__label"
                    [datiqTemplateMd]="settings?.title"
                ></span>
            </header>
            <ng-container *ngIf="settings?.description?.length">
                <section class="datiq-tooltip__description">
                    <span class="datiq-tooltip__description__icon"
                        ><mat-icon svgIcon="app:info"></mat-icon
                    ></span>
                    <span
                        class="datiq-tooltip__description__label"
                        [datiqTemplateMd]="settings?.description"
                    ></span>
                </section>
            </ng-container>
        </div>
    </ng-template>
</ng-container>
